import { render } from "./Exam.vue?vue&type=template&id=4924fe78&scoped=true"
import script from "./Exam.vue?vue&type=script&lang=js"
export * from "./Exam.vue?vue&type=script&lang=js"

import "./Exam.vue?vue&type=style&index=0&id=4924fe78&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bmark-kid/bmark-kid-manage-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4924fe78"]])

export default __exports__